type PropertyAddressSource = {
  full_address?: string;
  street?: string;
  ward_name?: string;
  province_name?: string;
  location?: string;
  title?: string;
  name?: string;
  property_name?: string;
  room_number?: string | null;
  roomNumber?: string | null;
  address?: string | {
    full_address?: string;
    fullAddress?: string;
    street?: string;
    ward_name?: string;
    ward?: string;
    province_name?: string;
    province?: string;
  };
};

function readRoomNumber(property?: PropertyAddressSource | null): string {
  return String(property?.room_number || property?.roomNumber || '').trim();
}

/** Số phòng để hiện ra: "Căn A101" */
export function getPropertyRoomLabel(property?: PropertyAddressSource | null): string {
  const room = readRoomNumber(property);
  if (!room) return '';
  if (/^(căn|phòng)\b/i.test(room)) return room;
  return `Căn ${room}`;
}

function readAddressOnly(property?: PropertyAddressSource | null): string {
  if (!property) return '';

  try {
    if (property.full_address?.trim()) {
      return property.full_address.trim();
    }

    if (property.street && property.ward_name) {
      return `${property.street} - ${property.ward_name}${property.province_name ? ` - ${property.province_name}` : ''}`;
    }

    if (typeof property.address === 'string' && property.address.trim()) {
      return property.address.trim();
    }

    if (property.address && typeof property.address === 'object') {
      const addr = property.address;
      if (addr.full_address?.trim()) {
        return addr.full_address.trim();
      }
      if (addr.fullAddress?.trim()) {
        return addr.fullAddress.trim();
      }
      if (addr.street && (addr.ward_name || addr.ward)) {
        return `${addr.street} - ${addr.ward_name || addr.ward}${addr.province_name || addr.province ? ` - ${addr.province_name || addr.province}` : ''}`;
      }
      const parts = [
        addr.street,
        addr.ward_name || addr.ward,
        addr.province_name || addr.province,
      ].filter(Boolean);
      if (parts.length) {
        return parts.join(' - ');
      }
    }

    if (property.location?.trim()) {
      return property.location.trim();
    }
  } catch {
    // ignore
  }

  return '';
}

/** Lấy địa chỉ hiển thị giống product card trên trang cá nhân */
export function getPropertyDisplayAddress(property?: PropertyAddressSource | null): string {
  const address = readAddressOnly(property);
  if (address) return address;
  if (property?.title?.trim()) {
    return property.title.trim();
  }
  if (property?.name?.trim()) {
    return property.name.trim();
  }
  if (property?.property_name?.trim()) {
    return property.property_name.trim();
  }
  if (typeof property?.address === 'string') {
    return property.address;
  }
  return property?.full_address || '';
}

/**
 * Tên hiển thị thay cho tiêu đề: địa chỉ + số phòng.
 * Nếu UI đã hiện địa chỉ thì chỉ trả số phòng (và ngược lại).
 */
export function getPropertyDisplayHeading(
  property?: PropertyAddressSource | null,
  options?: { alreadyShowsAddress?: boolean; alreadyShowsRoom?: boolean }
): string {
  const address = readAddressOnly(property);
  const room = getPropertyRoomLabel(property);
  const alreadyAddress = Boolean(options?.alreadyShowsAddress);
  const alreadyRoom = Boolean(options?.alreadyShowsRoom);
  const fallback = 'Bất động sản';
  const storedName = (property?.title || property?.name || property?.property_name || '').trim();

  if (alreadyAddress && alreadyRoom) {
    return fallback;
  }
  if (alreadyAddress) {
    return room || fallback;
  }
  if (alreadyRoom) {
    return address || fallback;
  }
  if (room && address) {
    return `${room} · ${address}`;
  }
  return address || room || storedName || fallback;
}

